import { environment, variablesGlobales } from "../../../configs/variables";


const baseUrl = variablesGlobales.urlServiceBackend;

// Referrals
//Send mail to referral
export const SEND_MAIL_REFERRAL = baseUrl + "/api/v1/referrals/sendMailReferral";
export const GENERATE_QR_CODE = environment !== 'PROD' ? "https://dev.galilea.co:8443/sandbox/qr/api/v1/generate-qr-referral" :
    "https://backend-lb.galilea.co/prod/qr/api/v1/generate-qr-referral"